const clipboard = {
  get supported() {
    return (
      typeof navigator !== 'undefined' &&
      navigator.clipboard?.writeText !== undefined
    )
  },
  copyText,
}

function copyText(text: string): Promise<void> {
  if (!clipboard.supported) {
    throw new Error('Clipboard is not supported in your browser')
  }

  return navigator.clipboard.writeText(text)
}

export default clipboard
